









































import { Component, Prop, Vue } from 'vue-property-decorator';
import ProjectIdCard from "@/components/ProjectIdCard.vue"
import PortfolioProjectOverview from "@/components/PortfolioProjectOverview.vue"
import TimeSeriesChart from "@/components/TimeSeriesChart.vue";
import ProjectPerformanceDailyCarousel from "@/components/ProjectPerformanceDailyCarousel.vue"
import { TimeChartData, TimeChartDataSet } from '@/models/chart-data';
import { Project, ProjectPerformance } from '@/models/project';
import {ProjectService} from "@/services/project-service";

@Component({
    name: 'PortfolioProjectDetails',
    components: {
        ProjectIdCard,
        PortfolioProjectOverview,
        TimeSeriesChart,
        ProjectPerformanceDailyCarousel
    }
})
export default class PortfolioProjectDetails extends Vue {
    @Prop() private projectId!: string;

    private project: Project = new Project;
    project_service: ProjectService = new ProjectService();

    project_progress_data: TimeChartData = new TimeChartData();
    project_perfromance_data: ProjectPerformance = new ProjectPerformance();

    created () {
        this.loadProject();
        this.loadChartsData();
        this.loadPerformanceData();
    }

    getProject() {
        return this.project
    }

    loadProject() {
        this.project_service.getProjectById(this.projectId)
            .then((response) => {
                if (response) {
                    this.project = response
                    //Object.assign(this.project, response)                        
                }
            })
    }

    get yAxesConf() {
        return [
            {
                id: 'money',
                type: 'linear',
                position: 'right'
            },
            {
                id: 'percentage',
                type: 'linear',
                position: 'left',
                ticks: {
                    max: 100,
                    beginAtZero: true,
                }
            },
        ];
    }

    loadChartsData() {
        this.project_service.getProjectPerformanceTimeChartDataById(this.projectId)
            .then((response) => {
                if (response) {
                    this.project_progress_data = response
                    this.project_progress_data.datasets[0].borderColor = "#00B4DA";
                    this.project_progress_data.datasets[0].backgroundColor = "#7FCEFD";
                    this.project_progress_data.datasets[0].yAxisID = "money";
                    this.project_progress_data.datasets[1].borderColor = "#E31C68";
                    this.project_progress_data.datasets[1].backgroundColor = "#FF9CB3";
                    this.project_progress_data.datasets[1].yAxisID = "money";
                    //this.project_progress_data.datasets[2].borderColor = TBD;
                    //this.project_progress_data.datasets[2].backgroundColor = TBD;
                    this.project_progress_data.datasets[2].yAxisID = "percentage";
                }
            })
    }

    loadPerformanceData() {
        this.project_service.getProjectPerformanceById(this.projectId)
            .then((response) => {
                if (response) {
                    this.project_perfromance_data = response
                    console.log("***** " + JSON.stringify(this.project_perfromance_data))
                }
        })
    }

    get dailyPerfs() {
        return this.project_perfromance_data.time_performance?.by_day
    }

}
